'use strict';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IdynamicFormItem } from '../../../shared/dynamic-form/interfaces/IdynamicFormItem';
import set = Reflect.set;

@Component({
  selector: 'gen-curation-filter-container',
  templateUrl: 'curation-filter-container.component.html',
  styleUrls: ['curation-filter-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurationFilterContainerComponent implements OnInit {
  @Output() filterUpdated: EventEmitter<any> = new EventEmitter();
  @Input() formName: string;
  @Input() vertical: boolean;
  @Input() submitted: boolean = false;
  public formConfig: { id: string, inputs: IdynamicFormItem[]};
  public form: any;
  public restForm: boolean = false;

  private _changedFields: any = { };
  private _filterKeys: any = new Set();
  private _defaultFieldValues: any = { };

  constructor() { }

  ngOnInit() {
  }

  /*apply(){
    for(let key in this.filterObject){
      const item = this.filterObject[key];
      if(this.filterObject[key] === null) continue;
      if(Array.isArray(item)){
        item = item.join();
      }else if(typeof item  === "object"){
        item = item.display;
      }


    }
  }*/

  formChanged(form, updateFieldKeys: any) {
    this.restForm = false;

    for (const key of updateFieldKeys) {
      this._changedFields[key] = form[key];
      this._filterKeys.add(key);
    }
  }

  formInit(form: any) {
    const oldFilterKeys = new Set(this._filterKeys);
    const oldChangedFields = this._changedFields;
    this._changedFields = { };

    this._filterKeys.clear();
    this._defaultFieldValues = { };

    for (const key of Object.keys(form)) {
      this._defaultFieldValues[key] = form[key];
      this._changedFields[key] = form[key];
      this._filterKeys.add(key);
    }

    this.submitIfChanged(oldFilterKeys, oldChangedFields);
  }

  submitIfChanged(oldFilterKeys: any, oldChangedFields: any) {
    let needToSubmit = false;

    if (oldFilterKeys.size != this._filterKeys.size) {
      needToSubmit = true;
    } else {
      for (const key of oldFilterKeys) {
        if (!this._filterKeys.has(key)) {
          needToSubmit = true;
          break;
        } else {
          const currentValue = this.extractPropertyValue(this._changedFields[key], key);
          const oldValue = this.extractPropertyValue(oldChangedFields[key], key);

          if ((currentValue && !oldValue) || (!currentValue && oldValue) || (currentValue !== oldValue) ) {
            needToSubmit = true;
            break;
          }
        }
      }
    }

    if (needToSubmit) {
      this.submit(null);
    }
  }

  submit(model) {
    const filterJson = { };

    for (const key of this._filterKeys) {
      if (this._changedFields[key]) {
        const value = this.extractPropertyValue(this._changedFields[key], key);

        if (value && value !== '') {
          filterJson[key] = value;
        }
      }
    }

    this.filterUpdated.emit(filterJson);
  }

  extractPropertyValue(propertyValue: any, key: string) {
    let value;
    if (typeof(propertyValue) == 'string') {
      value = propertyValue;
    } else if (Array.isArray(propertyValue)) {
      value = propertyValue.join();

      if (!value || value === '') {
        value = this._defaultFieldValues[key].join();
      }
    } else {
      value = propertyValue.display;
    }

    return value;
  }

  cancel(model) {
    this.restForm = true;
  }
}
